import { Grid } from '@material-ui/core';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

export const entityDependenciesContent = EntityContentBlueprint.make({
  name: 'dependencies',
  params: {
    path: 'dependencies',
    title: 'Dependências',
    filter: 'kind:component',
    loader: async () => {
      const { EntityDependsOnComponentsCard, EntityDependsOnResourcesCard } =
        await import('@backstage/plugin-catalog');
      return (
        <Grid container spacing={3} alignItems="stretch">
          <Grid item md={6}>
            <EntityDependsOnComponentsCard />
          </Grid>
          <Grid item md={6}>
            <EntityDependsOnResourcesCard />
          </Grid>
        </Grid>
      );
    },
  },
});
